// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.scroller_r6cM3 {
  width: 100%;
  max-width: calc(100vw - 236px);
  overflow: hidden;
  position: relative;
  margin: 10px 0;
  @media (width<=1128px) {
    max-width: calc(100vw - 210px);
  }
  @media (width<=768px) {
    max-width: calc(100vw - 0px);
  }
}

.scrollerInner_Pe5rv {
  display: flex;
  flex-wrap: nowrap;
  width: max-content;
  svg{
    fill: var(--black-border);
  }
}

.scroller_r6cM3.scrollLeft_Nj_J3 .scrollerInner_Pe5rv {
  animation: scrollLeft_Nj_J3 var(--_animation-duration, 40s) linear infinite;
}

.scroller_r6cM3.scrollRight_iAfjv .scrollerInner_Pe5rv {
  animation: scrollRight_iAfjv var(--_animation-duration, 40s) linear infinite;
}

.scroller_r6cM3:hover .scrollerInner_Pe5rv {
  animation-play-state: paused;
}

@keyframes scrollLeft_Nj_J3 {
  from {
    transform: translateX(0%);
  }
  to {
    transform: translateX(-50%);
  }
}

@keyframes scrollRight_iAfjv {
  from {
    transform: translateX(-50%);
  }
  to {
    transform: translateX(0%);
  }
}

.scroller_r6cM3[data-speed="fast"] {
  --_animation-duration: 20s;
}

.scroller_r6cM3[data-speed="slow"] {
  --_animation-duration: 100s;
}

.tagList_BaQdU li.hidden_2XYSd {
  opacity: 0.4;
  transition: opacity 0.5s ease-in-out;
}

.tagList_BaQdU {
  display: flex;
  gap: 1rem;
  list-style: none;
  padding: 0;
  margin: 0;
}

.tagList_BaQdU li {
  display: flex;
  padding: 16px;
  border-radius: 6px;
  align-items: center;
  background: var(--_0000000a-background);
  gap: 10px;
  cursor: pointer;
  width: 240px;
  transition: all 0.3s ease-in-out;
  color: var(--black-color);
  svg{
    height: 12px;
    width: 12px;
    min-width: 12px;
    min-height: 12px;
  }
  img {
    height: 20px;
    width: 20px;
  }
}

.tagList_BaQdU li:hover {
  background: var(--_0000001a-shadow);
}
`, "",{"version":3,"sources":["webpack://./src/views/Dashboard/screens/ChatView/ChatTags/Scroller.module.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,8BAA8B;EAC9B,gBAAgB;EAChB,kBAAkB;EAClB,cAAc;EACd;IACE,8BAA8B;EAChC;EACA;IACE,4BAA4B;EAC9B;AACF;;AAEA;EACE,aAAa;EACb,iBAAiB;EACjB,kBAAkB;EAClB;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE,2EAAqE;AACvE;;AAEA;EACE,4EAAsE;AACxE;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE;IACE,yBAAyB;EAC3B;EACA;IACE,2BAA2B;EAC7B;AACF;;AAEA;EACE;IACE,2BAA2B;EAC7B;EACA;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,YAAY;EACZ,oCAAoC;AACtC;;AAEA;EACE,aAAa;EACb,SAAS;EACT,gBAAgB;EAChB,UAAU;EACV,SAAS;AACX;;AAEA;EACE,aAAa;EACb,aAAa;EACb,kBAAkB;EAClB,mBAAmB;EACnB,uCAAuC;EACvC,SAAS;EACT,eAAe;EACf,YAAY;EACZ,gCAAgC;EAChC,yBAAyB;EACzB;IACE,YAAY;IACZ,WAAW;IACX,eAAe;IACf,gBAAgB;EAClB;EACA;IACE,YAAY;IACZ,WAAW;EACb;AACF;;AAEA;EACE,mCAAmC;AACrC","sourcesContent":[".scroller {\n  width: 100%;\n  max-width: calc(100vw - 236px);\n  overflow: hidden;\n  position: relative;\n  margin: 10px 0;\n  @media (width<=1128px) {\n    max-width: calc(100vw - 210px);\n  }\n  @media (width<=768px) {\n    max-width: calc(100vw - 0px);\n  }\n}\n\n.scrollerInner {\n  display: flex;\n  flex-wrap: nowrap;\n  width: max-content;\n  svg{\n    fill: var(--black-border);\n  }\n}\n\n.scroller.scrollLeft .scrollerInner {\n  animation: scrollLeft var(--_animation-duration, 40s) linear infinite;\n}\n\n.scroller.scrollRight .scrollerInner {\n  animation: scrollRight var(--_animation-duration, 40s) linear infinite;\n}\n\n.scroller:hover .scrollerInner {\n  animation-play-state: paused;\n}\n\n@keyframes scrollLeft {\n  from {\n    transform: translateX(0%);\n  }\n  to {\n    transform: translateX(-50%);\n  }\n}\n\n@keyframes scrollRight {\n  from {\n    transform: translateX(-50%);\n  }\n  to {\n    transform: translateX(0%);\n  }\n}\n\n.scroller[data-speed=\"fast\"] {\n  --_animation-duration: 20s;\n}\n\n.scroller[data-speed=\"slow\"] {\n  --_animation-duration: 100s;\n}\n\n.tagList li.hidden {\n  opacity: 0.4;\n  transition: opacity 0.5s ease-in-out;\n}\n\n.tagList {\n  display: flex;\n  gap: 1rem;\n  list-style: none;\n  padding: 0;\n  margin: 0;\n}\n\n.tagList li {\n  display: flex;\n  padding: 16px;\n  border-radius: 6px;\n  align-items: center;\n  background: var(--_0000000a-background);\n  gap: 10px;\n  cursor: pointer;\n  width: 240px;\n  transition: all 0.3s ease-in-out;\n  color: var(--black-color);\n  svg{\n    height: 12px;\n    width: 12px;\n    min-width: 12px;\n    min-height: 12px;\n  }\n  img {\n    height: 20px;\n    width: 20px;\n  }\n}\n\n.tagList li:hover {\n  background: var(--_0000001a-shadow);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"scroller": `scroller_r6cM3`,
	"scrollerInner": `scrollerInner_Pe5rv`,
	"scrollLeft": `scrollLeft_Nj_J3`,
	"scrollRight": `scrollRight_iAfjv`,
	"tagList": `tagList_BaQdU`,
	"hidden": `hidden_2XYSd`
};
export default ___CSS_LOADER_EXPORT___;
